/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { Button, CircularProgress, Grid } from "@mui/material";
import { Fragment, useContext, useEffect, useState } from "react";
import { getData } from "../../Services/getData";
import { UrlEnum } from "../../Utils/Utils";
import { useLocation } from "react-router-dom";
import { BreadCrumbsContext } from "../../Context/breadCrumbsContext";
import { toast } from "react-toastify";
import QuestionsDetails from "./QuestionsDetails";
import DeviceDetails from "./DeviceDetails";
import PriceAndPayment from "./PriceAndPayment";
import StatusOrder from "./StatusOrder";
import { postData } from "../../Services/postData";
import { Vocabulary } from "../../Utils/Vocabulary";
import OrderDetails from "./OrderDetails";
import theme from "../../Theme/Theme";
import SaveIcon from "@mui/icons-material/Save";
import SendEmailModal from "./SendEmailModal";
import ShowDocuments from "./ShowDocuments";
import { BadgeContext } from "../../Context/badgeContext";
import { breadCrumbsEnum } from "../../Utils/Constants";
import OrderShipping from "./OrderShipping";
import style from "./Orders.module.scss";

const styles = {
  color: "black",
  boxShadow: "none",
  width: "calc(100% - 260px)",
};
export default function Order() {
  const location = useLocation();
  const breadCrumbsContext = useContext(BreadCrumbsContext);
  const badgeContext = useContext(BadgeContext);
  const notifyError = (message: string) => toast.error(message);
  const notifySuccess = (message: string) => toast.success(message);
  const [emailTemplate, setEmailTemplate] = useState(null);
  const [sendEmailModal, setSendEmailModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState<any>(null);
  const userName = localStorage.getItem("userName")
    ? localStorage.getItem("userName")
    : "";

  /**
   *
   */
  useEffect(() => {
    let id = location.pathname;
    id = id.replace("/orders/", "");
    if (id !== "0" && !order) {
      getOrder(id);
    }
  }, []);

  useEffect(() => {
    if (order && order.statusId) {
      if (order.status.order.toLowerCase().includes("awb") &&
        order.fanCourierInfo?.awb &&
        order.fanCourierInfo?.orderNumber) {
        saveOrderClickHandler();
      }
    }
  }, [order]);

  /**
   *
   * @param id
   */
  function getOrder(id: string) {
    setLoading(true);
    getData(`${UrlEnum.orders}/${id}`)
      .then((res) => {
        breadCrumbsContext.setBreadCrumbs([
          `${breadCrumbsEnum.orders}`,
          `${res.data[0].orderNumber}`,
        ]);
        setOrder(res.data[0]);
        if (res.data[0].isNew) {
          badgeContext.setOrdersNumber(badgeContext.ordersNumber - 1);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        notifyError(Vocabulary.getError);
      });
  }

  /**
   *
   * @param e
   */
  function handleChangePrice(e: any) {
    setOrder({ ...order, estimatedPrice: e.target.value });
  }

  /**
   *
   * @param key
   * @param value
   */
  function handleChangeStatus(
    id: string | null | undefined,
    value: string | undefined
  ) {
    const newStatus = Object.assign({}, order.status);
    newStatus["order"] = value;
    order.statusId = id;
    setOrder({ ...order, status: newStatus });
  }

  /**
   *
   * @param key
   * @param value
   */
  function handleChangePersonalDataValue(key: string, value: string | any) {
    const newPersonalData = Object.assign({}, order.personalData);
    newPersonalData[key] = value;
    setOrder({ ...order, personalData: newPersonalData });
  }

  /**
   *
   * @param key
   * @param value
   */
  function handleChangePaymentInfoValue(key: string, value: string | any) {
    const newPaymentInfo = Object.assign({}, order.paymentInfo);
    newPaymentInfo[key] = value;
    setOrder({ ...order, paymentInfo: newPaymentInfo });
  }

  /**
   *
   * @param key
   * @param value
   */
  function handleChangeDeviceDetailsValue(key: string, value: string | any) {
    const newDeviceDetails = Object.assign({}, order.deviceDetails);
    newDeviceDetails[key] = value;

    const update: any = { deviceDetails: newDeviceDetails };

    if (Array.isArray(order.devices) && order.devices.length > 0) {
      const newDevices = [...order.devices];
      newDevices[0] = { ...newDevices[0], deviceDetails: newDeviceDetails };
      update.devices = newDevices;
    }

    setOrder({ ...order, ...update });
  }

  /**
   *
   * @param deviceIndex
   * @param key
   * @param value
   */
  function handleChangeDeviceFieldValue(deviceIndex: number, key: string, value: string | any) {
    const newDevices = [...order.devices];
    newDevices[deviceIndex] = {
      ...newDevices[deviceIndex],
      deviceDetails: { ...newDevices[deviceIndex].deviceDetails, [key]: value },
    };
    const update: any = { devices: newDevices };
    if (deviceIndex === 0) update.deviceDetails = newDevices[0].deviceDetails;
    setOrder({ ...order, ...update });
  }

  /**
   *
   * @param deviceIndex
   * @param price
   */
  function handleChangeDevicePrice(deviceIndex: number, price: number) {
    const newDevices = [...order.devices];
    newDevices[deviceIndex] = { ...newDevices[deviceIndex], estimatedPrice: price };
    const totalPrice = newDevices.reduce((sum: number, d: any) => sum + (Number(d.estimatedPrice) || 0), 0);
    setOrder({ ...order, devices: newDevices, estimatedPrice: totalPrice });
  }

  /**
   *
   * @param deviceIndex
   */
  function handleDeleteDevice(deviceIndex: number) {
    if (!order.devices || order.devices.length <= 1) return;
    const newDevices = order.devices.filter((_: any, i: number) => i !== deviceIndex);
    const totalPrice = newDevices.reduce((sum: number, d: any) => sum + (Number(d.estimatedPrice) || 0), 0);
    setOrder({
      ...order,
      devices: newDevices,
      deviceDetails: newDevices[0].deviceDetails,
      estimatedPrice: totalPrice,
      answers: newDevices[0].answers,
    });
  }

  /**
   *
   * @param value
   */
  function handleChangePaymentType(value: string) {
    setOrder({ ...order, paymentType: value });
  }

  /**
   *
   * @param customerDetails
   */
  function handleChangeCustomerDetails(customerDetails: any) {
    setOrder({ ...order, customer: customerDetails });
  }
  /**
   *
   * @param statusId
   */
  async function getEmailTemplate(statusId: string) {
    await getData(`${UrlEnum.emailTemplates}/${statusId}`)
      .then((res) => {
        setEmailTemplate(res.data[0]);
      })
      .catch((err) => {
        setSendEmailModal(false);
        notifyError(Vocabulary.getError);
      });
  }
  /**
   *
   */
  function onSaveOrder(value: boolean, body?: any) {
    return new Promise((resolve, reject) => {
      let postBody = { ...order };
      if (body) {
        postBody = { ...order, ...body };
      }
      setLoading(true);
      postBody.sendEmail = value;
      postBody.userName = userName;
      // send email and save order + documents
      if (body) {
        const formData = new FormData() as any;
        body.attachments.forEach((attachment: any) => {
          formData.append("files", attachment, attachment.name);
        });
        postData(UrlEnum.sendEmail, formData)
          .then((res) => {
            for (let i = 0; i < res.data.length; i++)
              postBody.attachments[i] = {
                content: res.data[i],
                filename: res.data[i],
                type: postBody.attachments[i].type,
                disposition: "attachment",
              };
            if (order.documents)
              postBody.documents = [...order.documents, ...res.data];
            else postBody.documents = res.data;
            postData(`${UrlEnum.orders}/${order._id}`, postBody)
              .then((response) => {
                setLoading(false);
                setSendEmailModal(false);
                notifySuccess(Vocabulary.saveSuccess);
                resolve(response);
                // setOrder(response);
              })
              .catch((error) => {
                reject(error);
                setLoading(false);
                notifyError(Vocabulary.saveError);
              });
          })
          .catch((err) => {
            setLoading(false);
            notifyError(Vocabulary.saveError);
          });
        //save without sending email
      } else {
        postData(`${UrlEnum.orders}/${order._id}`, postBody)
          .then((response) => {
            setLoading(false);
            notifySuccess(Vocabulary.saveSuccess);
            resolve(response);
            // setOrder(response);
          })
          .catch((error) => {
            reject(error);
            setLoading(false);
            notifyError(Vocabulary.saveError);
          });
      }
    });

  }

  /**
   *
   */
  function handleChangeOrder(newOrder: any) {
    setOrder(newOrder);
  }

  /**
   * 
   */
  function saveOrderClickHandler() {
    if (order && order.statusId) {
      setSendEmailModal(true);
      getEmailTemplate(order.statusId);
    } else {
      onSaveOrder(false);
    }
  }
  return (
    <>
      {order ? (
        <StatusOrder
          isOrder={true}
          status={order.status.order}
          handleChangeStatus={handleChangeStatus}
          name="orderStatus"
          styles={styles}
        />
      ) : (
        ""
      )}
      <Grid
        id="forPrint"
        container
        spacing={2}
        style={{ marginTop: 30, marginBottom: 40 }}
      >
        <OrderDetails order={order} />
        {order?.devices?.length > 0 ? (
          order.devices.map((device: any, index: number) => (
            <Fragment key={device.deviceDetails?.deviceName || index}>
              <DeviceDetails
                title={`${Vocabulary.device} ${index + 1} – ${device.deviceDetails?.deviceName || ""}`}
                details={device.deviceDetails}
                onDelete={order.devices.length > 1 ? () => handleDeleteDevice(index) : undefined}
                handleChangeDeviceDetailsValue={(key, value) =>
                  handleChangeDeviceFieldValue(index, key, value)
                }
              />
              <QuestionsDetails
                title={`${Vocabulary.questions} – ${device.deviceDetails?.deviceName || `${Vocabulary.device} ${index + 1}`}`}
                details={device.answers || []}
              />
            </Fragment>
          ))
        ) : (
          <>
            <DeviceDetails
              details={order ? order.deviceDetails : ""}
              handleChangeDeviceDetailsValue={handleChangeDeviceDetailsValue}
            />
            <QuestionsDetails
              title={Vocabulary.questions}
              details={order ? order.answers : []}
            />
          </>
        )}
        <PriceAndPayment
          order={order}
          handleChangePaymentType={handleChangePaymentType}
          handleChangePrice={handleChangePrice}
          handleChangeDevicePrice={handleChangeDevicePrice}
          handleChangePersonalDataValue={handleChangePersonalDataValue}
          handleChangePaymentInfoValue={handleChangePaymentInfoValue}
          handleChangeCustomerDetails={handleChangeCustomerDetails}
        />

        <OrderShipping
          fanCourierInfo={order?.fanCourierInfo || null}
          fanCourierInfoReturn={order?.fanCourierInfoReturn || null}
          shipping={order?.shipping || null}
          handleChangeShipping={(shipping: any) => {
            setOrder({ ...order, shipping: shipping });
          }}
          order={order}
          handleChangeOrder={handleChangeOrder}
          saveOrder={onSaveOrder}
        />
      </Grid>
      {order && order.documents && order.documents.length !== 0 ? (
        <ShowDocuments documents={order.documents} />
      ) : (
        ""
      )}
      <div
        className={style.bottomBar}
      >
        <Button
          variant="contained"
          size="large"
          style={{
            padding: 10,
            color: theme.palette.whiteColor?.main,
          }}
          onClick={saveOrderClickHandler}
        >
          <SaveIcon /> &nbsp;&nbsp; {Vocabulary.save}
        </Button>
      </div>

      <SendEmailModal
        open={sendEmailModal}
        data={emailTemplate}
        onClose={() => {
          setSendEmailModal(false);
          setEmailTemplate(null);
        }}
        handleSendEmail={(value: boolean, body?: any) => {
          onSaveOrder(value, body);
          setSendEmailModal(false);
        }}
        title={""}
      />
      {loading ? (
        <div className="loading">
          <CircularProgress color="primary" />
        </div>
      ) : (
        ""
      )}
    </>
  );
}
